export { default as URLS } from './urls';
export * from './experiments';
export { default as LAYOUTS } from './layout';

/**
 * The localStorage/cookie key that holds a patient's answer to the referrer-type
 * survey as its value.
 */
export const REFERRER_TYPE_STORAGE_KEY = 'referrer-type';

/**
 * For auto-advancing radio button inputs: the timeout between selecting an option
 * and triggering the navigation forward
 */
export const AUTO_ADVANCING_OPTION_SELECT_WAIT_MS = 250;

/**
 * Quiz architecture only: Time to wait before allowing additional navigation
 * after finishing a navigation event
 */
export const NAVIGATION_WAIT_MS = 500;

/**
 * Twilio number to send photos to during signup
 */
export const SMS_NUMBER_PHOTO_UPLOAD = 49486;
